<template>
  <v-row justify="center">
    <v-col v-for="(person, index) in persons" cols="auto" @click="onSelect(index)">
      <v-sheet elevation="5" rounded class="personContainer">
        <div class="imageContainer"
             :style="{backgroundImage: 'url(' + getImageUrl(getPersonPreviewImage(person).smallUrl) + ')'}"></div>
        <div class="codeContainer">
          <p class="code">{{ person.code }}</p>
        </div>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ImageDto, ImageOrientationDto, PersonDto} from "@swagger";

@Component({
  components: {}
})
export default class PersonSelector extends BasicComponent {

  @Prop(Number) value: number; // The index of the selected person
  @Prop(Array) persons: PersonDto[];

  getPersonPreviewImage(person: PersonDto): ImageDto {
    const images = this.getPersonImages(person);
    const firstLandscape = images.find(image => image.orientation === ImageOrientationDto.LANDSCAPE);
    if (firstLandscape) return firstLandscape;
    return images[0];
  }

  onSelect(index: number): void {
    this.$emit("input", index);
    this.$emit("select");
  }

}

</script>
<style lang="scss" scoped>

.personContainer {
  margin: 4px;

  &:hover {
    cursor: pointer;
    transform: scale(0.95);
  }

  .imageContainer {
    background-size: cover;
    background-position: center;
    height: 128px;
    width: 192px;
  }

  .codeContainer {
    display: inline-block;
    width: 100%;
    padding: 10px;

    .code {
      display: inline-block;
      width: 100%;
      text-align: center;
      margin: 10px 0;
      font-weight: bold;
    }
  }
}

</style>
<style lang="scss">

</style>